{
  "version": 1,
  "asset_id": "dc2b8ae9-b0db-4439-a468-36321ca277a4",
  "project_id": "7948fbe6-b4e3-485f-995c-f8f53bd7ab6b",
  "url": "/__l5e/assets-v1/dc2b8ae9-b0db-4439-a468-36321ca277a4/arwen-master-suite.png",
  "r2_key": "a/v1/7948fbe6-b4e3-485f-995c-f8f53bd7ab6b/dc2b8ae9-b0db-4439-a468-36321ca277a4/arwen-master-suite.png",
  "original_filename": "arwen-master-suite.png",
  "size": 1474258,
  "content_type": "image/png",
  "created_at": "2026-07-05T03:24:52Z"
}
